<template>
  <MRow class="h-full">
    <MCol :size="12" class="flex flex-col h-full">
      <MRow>
        <MCol :size="12">
          <h5 class="mb-0">
            {{ announcement.name }}
          </h5>
        </MCol>
      </MRow>
      <MDivider />
      <MRow class="flex-1 min-h-0">
        <MCol :size="12" class="h-full">
          <FlotoScrollView>
            <div class="w-full overflow-hidden flex-1 flex flex-col">
              <FlotoRichEditor
                :value="announcement.announcementDescription"
                disabled
              />
            </div>
          </FlotoScrollView>
        </MCol>
      </MRow>
    </MCol>
  </MRow>
</template>

<script>
export default {
  name: 'AnnouncementView',
  props: {
    announcement: { type: Object, required: true },
  },
}
</script>
